import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
Axios.defaults.baseURL = API_URL;

export class HttpService {
  _axios = Axios.create();

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url) => await this.request(this.getOptionsConfig("get", url));

  getFile = async (url) => {
    return await this.request({
      method: "get",
      url,
      responseType: "blob",
    });
  };

  post = async (url, data) =>
    await this.request(this.getOptionsConfig("post", url, data));

  postFile = async (url, data) => {
    return await this.request({
      method: "post",
      url,
      data,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Credentials": true,
      },
    });
  };

  put = async (url, data) =>
    await this.request(this.getOptionsConfig("put", url, data));

  patch = async (url, data) =>
    await this.request(this.getOptionsConfig("patch", url, data));

  delete = async (url, data = {}) =>
    await this.request(this.getOptionsConfig("delete", url, data));

  getOptionsConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      headers: {
        "Content-Type": "application/vnd.api+json",
        Accept: "application/vnd.api+json",
        "Access-Control-Allow-Credentials": true,
      },
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        // Sem response (rede/CORS) o ex.response.data quebrava aqui e a
        // promise nunca terminava (tela presa em "carregando").
        .catch((ex) =>
          reject(
            ex.response?.data ?? { error: ex.message, message: ex.message }
          )
        );
    });
  }
}

export default new HttpService();
